import React from 'react';
import { Outlet } from 'react-router-dom';

const TrainingsPage = () => {
  return <Outlet />;
};

export default TrainingsPage;
